export default __webpack_public_path__ + "static/media/computer-and-phone.09bd98ae.png";